import { useMutation, useQuery } from "@tanstack/react-query";
import { subjectCheckinService } from "./subjectcheckin.api";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statuscode: number;
}

export const useSubjectCheckin = ({
  searchText,
  pageNumber,
  pageSize,
  subjectCheckinId,
  periodId,
  studyId,
}: {
  searchText?: string | null;
  pageNumber?: number;
  pageSize?: number;
  subjectCheckinId?: number | null;
  periodId?: string | null;
  studyId?: number | string | null;
} = {}) => {
  const SelectAllQuery = useQuery({
    queryKey: [
      "subjectcheckin-selectAll",
      { searchText, pageNumber, pageSize, periodId, studyId },
    ],
    queryFn: () =>
      subjectCheckinService.getSelectAllData({
        searchtext: (searchText ?? "").trim(),
        currentpage: pageNumber ?? 1,
        pagesize: pageSize ?? 10,
        status: "A",
        periodid: periodId ?? null,
        studyid: studyId ?? null,
      }),
    enabled: !!pageNumber && !!pageSize && !!periodId,
  });

  const SelectQuery = useQuery({
    queryKey: ["subjectcheckin-select", { subjectCheckinId }],
    queryFn: () =>
      subjectCheckinService.getSelectData({
        subjectcheckinid: subjectCheckinId!,
        status: "A",
      }),
    enabled: !!subjectCheckinId,
  });

  const UpdateMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload) => subjectCheckinService.updateData(payload),
  });

  const DeleteMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload) => subjectCheckinService.deleteData(payload),
  });

  return {
    SelectAllQuery,
    SelectQuery,
    UpdateMutation,
    DeleteMutation,
  };
};
